import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { crmApi } from "../api/client";
import { useSelectedCompany } from "../contexts/SelectedCompanyProvider";

const KEY = (scope, companyQueryParams) => ["crm", "saved-views", scope || "leads", companyQueryParams || {}];

export function useSavedViews(scope = "leads") {
  const { companyQueryParams } = useSelectedCompany();
  return useQuery({
    queryKey: KEY(scope, companyQueryParams),
    queryFn: async () => {
      const { data } = await crmApi.get("/saved-views", { params: { scope, ...companyQueryParams } });
      return data?.views || [];
    },
    staleTime: 60_000,
  });
}

export function useCreateSavedView(scope = "leads") {
  const qc = useQueryClient();
  const { companyQueryParams } = useSelectedCompany();
  return useMutation({
    mutationFn: async (payload) => (await crmApi.post("/saved-views", { ...payload, scope }, { params: companyQueryParams })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(scope, companyQueryParams) }),
  });
}

export function useUpdateSavedView(scope = "leads") {
  const qc = useQueryClient();
  const { companyQueryParams } = useSelectedCompany();
  return useMutation({
    mutationFn: async ({ id, patch }) => (await crmApi.patch(`/saved-views/${id}`, patch)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(scope, companyQueryParams) }),
  });
}

export function useDeleteSavedView(scope = "leads") {
  const qc = useQueryClient();
  const { companyQueryParams } = useSelectedCompany();
  return useMutation({
    mutationFn: async (id) => (await crmApi.delete(`/saved-views/${id}`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(scope, companyQueryParams) }),
  });
}
